<template>
  <div class="upsell-product mr-8 last:mr-0">
    <nuxt-link :to="route">
      <div class="h-112 w-full">
        <img
          :src="item.standardImage"
          class="w-full h-full object-cover rounded-regular"
          :alt="$lang('product_page', 'product_image_alt')"
          height="94"
          width="80"
        >
      </div>
    </nuxt-link>
    <nuxt-link :to="route">
      <div class="text-price mt-12">{{ item.price }}</div>
    </nuxt-link>
  </div>
</template>

<script setup lang="ts">
import Product from '~/models/product';
import { useConfigStore } from '~/store/config';
const config = useConfigStore();

const props = defineProps<{
  item: Product,
}>();

const route = computed(()=> {
  return config.getProductRoute(props.item.ecomId)?.route || '';
});

</script>

<style>
.upsell-product {
  width: calc(33% - 6px);
}
</style>
